import React, {ReactElement} from 'react';
import {InfoCircleIcon} from '@customink/pigment-react';
import Box from '@mui/material/Box';
import Tooltip from '../CustomTooltip';

interface DashboardToolTipProps extends React.HTMLAttributes<HTMLDivElement> {
  position?: 'top-start' | 'bottom-start' | 'top-end';
}

const DashboardToolTip: React.FC<DashboardToolTipProps> = ({
  position,
  children
}: DashboardToolTipProps): ReactElement => {
  return (
    <Tooltip
      className="dashboard-tooltip"
      title={<Box>{children}</Box>}
      arrow
      placement={position}>
      <span className="priceInfo-icon">
        <InfoCircleIcon fontSize="small" className="infoCircleIcon" />
      </span>
    </Tooltip>
  );
};

DashboardToolTip.defaultProps = {
  position: 'top-start'
};

export default DashboardToolTip;
